<template>
  <div id="example-id-search" class="editor-modal">
    <h2>{{ $t("data.example-id") }}</h2>
    <form @submit.stop.prevent>
      <custom-input
        @input="onFilterChange(searchString)"
        :inputType="'text'"
        :name="'searchString'"
        v-model="searchString"
        :placeholder="$t('data.reference-search')"
        :label="'ID'"
        :focusInputField="true"
      />
      <div class="icons">
        <div v-show="searching == true">
          <i class="search-icon fa-light fa-circle-notch fa-spin"></i>
        </div>
        <div v-show="searching == false">
          <i class="search-icon fa-light fa-search"></i>
        </div>
      </div>
    </form>
    <div class="result-list custom-scrollbar-light">
      <div
        v-for="result in searchResults"
        :key="result.id"
        class="result-item"
        :title="result.referenceName"
        @click="selectAsExampleId(result.id), $emit('close')"
      >
        <div class="flex-grow-1">
          <div>{{ result.referenceName }}</div>
          <div class="text-muted">{{ result.id }}</div>
        </div>
        <img src="@/assets/svg/chevronRight.svg" />
      </div>
      <div v-if="noMatch" class="no-results text-muted">
        {{ $t("tp-data-popover.no-result1") }} '{{ searchString }}' {{ $t("tp-data-popover.no-result2") }}
      </div>
    </div>

    <div class="footer">
      <button class="btn btn-md btn-secondary" type="reset" @click="$emit('close')">
        {{ $t("publication-stats.close") }}
      </button>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import debounce from "lodash/debounce";
export default {
  props: {
    templateId: [Number, String],
    selectAsExampleId: Function,
  },
  data() {
    return {
      searchString: null,
      searchResults: [],
      noMatch: false,
      searching: false,
      onFilterChangeDebounce: debounce((filter) => {
        if (filter.length) {
          this.noMatch = false;
          this.search(filter).then(() => (this.searching = false), () => (this.searching = false));
        } else {
          this.noMatch = true;
          this.searching = false;
        }
      }, 500),
    };
  },
  methods: {
    search() {
      return this.$store
        .dispatch("searchVariables", { filter: this.searchString, templateId: this.templateId })
        .then((result) => {
          this.searchResults = result;
          if (result.length == 0) {
            this.noMatch = true;
          } else {
            this.noMatch = false;
          }
        });
    },

    onFilterChange(filter) {
      // console.log(filter)
      this.searching = true;
      this.onFilterChangeDebounce(filter);
    },
  },
  components: {
    CustomInput
  },
};
</script>

<style lang="less">
#example-id-search {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0 0 10px 10px;
  }

  form {
    position: relative;
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    border-bottom: 1px solid rgba(143, 151, 156, 0.192);
    padding: 0 12px;
    input {
      width: 240px;
      margin-right: 10px;
    }
  }
  .footer {
    margin-top: 40px;
  }
  .stat-vars {
    display: flex;
    flex-direction: column;
    p {
      padding: 10px 0;
      padding: 10px 0.75rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(143, 151, 156, 0.192);
      span {
        cursor: default;
      }
    }
  }

  input#searchString {
    border: none;
  }
  .icons {
    position: absolute;
    right: 0;
    bottom: 8px;
  }

  .result-list {
    max-height: 300px;
    overflow: auto;
    .result-item {
      display: flex;
      padding: 5px 10px;
      cursor: pointer;
      span {
        flex-grow: 1;
      }
      img {
        display: none;
      }
      &:hover {
        background-color: rgba(219, 218, 218, 0.4);
        > img {
          display: block;
        }
      }

      &.is-selected {
        background-color: rgba(219, 218, 218);
        img {
          display: inline-block;
        }
      }
    }

    .no-results {
      text-align: center;
      padding: 20px;
    }
  }
}
</style>
